import { Controller, useFormContext } from 'react-hook-form';
import { Input } from '@ds';
import { OMSSchedulerSettingsInputsFormType } from '@lp/features/Scheduler/SchedulerOMSSettings/types';
import { getNumberInputValue, getNumberInputValueHandler } from '@lp/features/Scheduler/utils';

type OMSSchedulerSettingsInputsFormProps = {
  isReadOnly: boolean;
};

export const OMSSchedulerSettingsInputsForm = ({ isReadOnly }: OMSSchedulerSettingsInputsFormProps) => {
  const { control } = useFormContext<OMSSchedulerSettingsInputsFormType>();

  return (
    <div className="flex flex-col gap-5 w-full p-6 bg-white rounded-2xl shadow-s">
      <span className="text-base-5 text-xl-sb">Minimum OMS On Call Per Day</span>

      <div className="flex gap-4">
        <Controller
          name="minForFirstSlotPerOrgan"
          control={control}
          render={({ field: { value, onChange, ...field }, fieldState: { invalid, error } }) => (
            <Input
              type="number"
              aria-label="minForFirstSlotPerOrgan"
              isInvalid={invalid}
              isDisabled={isReadOnly}
              errorMessage={error?.message}
              className="max-w-[140px]"
              label="1st day-slot"
              placeholder="1st day-slot"
              value={getNumberInputValue(value)}
              onValueChange={getNumberInputValueHandler(onChange)}
              {...field}
            />
          )}
        />
        <Controller
          name="minForSecondSlotPerOrgan"
          control={control}
          render={({ field: { value, onChange, ...field }, fieldState: { invalid, error } }) => (
            <Input
              type="number"
              aria-label="minForSecondSlotPerOrgan"
              isInvalid={invalid}
              isDisabled={isReadOnly}
              errorMessage={error?.message}
              className="max-w-[140px]"
              label="2nd day-slot"
              placeholder="2nd day-slot"
              value={getNumberInputValue(value)}
              onValueChange={getNumberInputValueHandler(onChange)}
              {...field}
            />
          )}
        />
      </div>
    </div>
  );
};
